import angular from 'angular'

import { events } from './events'
import { licenseTypes } from './license_types'
import { tagValues } from './tag_values'
import { timezones } from './timezones'
import adminApi from './admin_api'
import graph from './graph'
import search from './search'
import toolkit from './toolkit'
import contentProfiles from './content_profiles'
import validators from './validators'
import adminEntitiesApi from './admin_entities_api'

export default angular
  .module('adminPanel.services', [])
  .constant('events', events)
  .constant('licenseTypes', licenseTypes)
  .constant('tagValues', tagValues)
  .constant('timezones', timezones)
  .factory('adminApi', adminApi)
  .factory('graph', graph)
  .factory('search', search)
  .factory('toolkit', toolkit)
  .factory('contentProfiles', contentProfiles)
  .factory('validators', validators)
  .factory('adminEntitiesApi', adminEntitiesApi)
